import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import HeaderTitle from "../../../../components/header/headerTitle/headerTitle";
import { ALL_ITEM_WATCH_PACKAGING } from "./itemJson";
import ItemList from "../../itemListContainer/itemList";

function ShoppingAidPage(props) {
  const [selectedItem, setSelectedItem] = useState([]);

  useEffect(() => {
    const jewelsParam = props.match.params.jewels;
    const filtered = ALL_ITEM_WATCH_PACKAGING[0].itemList.filter(item => item.itemSelected === jewelsParam);
    setSelectedItem(filtered)
  }, [props.match.params.jewels]); 


  return (
    <>
      <Helmet>
        <title>Luxury Watch Packaging | Tray & Box Case | Lussopack</title>
        <meta name="description" content="Browse our luxurious watch storage packaging options, including cases, displays, rolls, and trays, crafted to showcase and protect your timepieces with elegance." />
        <meta name="keywords" content="luxury watch packaging" />  
        <meta name="robots" content="noindex" />     
        <link rel="canonical" href="https://lussopack.com/packaging/watch-packaging/" />
      </Helmet>

      <HeaderTitle
        {...props}
        textHeader={"Luxury Watch Box Packaging"}
        textSubHeader={"Our watch box packaging options, including cases, displays, rolls, and trays, reflect the luxury and elegance of your timepieces."}
      />
             
      <ItemList 
        selectedItem={selectedItem}
      />
    </>
  );
}

export default ShoppingAidPage;
